export class UpiPaymentDetailDto {

    transAmt: number;
    merchantTranId: string;
    customerCode: string;
    transStatus: string;
    txnInitDate: string;
    refNo: string;
    upiCode: string;
    transDate: string;

    payerVA: string;
    bankRRN: string;
}
